import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import styles from './styles.module.css'
import { useEffect, useState } from "react";
import DragAndDrop from "./DragAndDrop";
import WhiteButton from '../../../components/WhiteButton'
import CloseIcon from '@mui/icons-material/Close';
import SecaoAdicionar from "./SecaoAdicionar";
import {buscarVinculosPorWorkflow } from "../../../services/api-planejamento-tributario.service";
import MensagemErro from "../../../components/MensagemErro";


const ModalWorkFlow = ({ open, onClose, data }) => {
    const [itens, setItens] = useState([]);
    const [msg, setMsg] = useState('')
    const [openErro, setOpenErro] = useState(false)

    useEffect(() => {
        const fetch = async () => {
            try {
                const response = await buscarVinculosPorWorkflow(data.idWkflProcesso)
              
                const listaItens = response.vinculosProcessosWkfl.map(item => {
                    return {
                        id: (item.id).toString(),
                        nome: item.usuario,
                        tipo: item.tipo
                    }
                })
                setItens(listaItens)
            } catch (error) {
                setItens([])
                setMsg(error.response.data.mensagem)
                handleOpenSnackbarErro()
            }

        }
        setItens([])
        data.idWkflProcesso && fetch()
    }, [data])

    const handleCloseSnackbarErro = (_, reason) => {
        if (!reason === "clickaway") {
            return;
        }
        setOpenErro(false);
    };

    const handleOpenSnackbarErro = () => {
        setOpenErro(true);
    };

    return (
        <div style={{ width: '60vw' }}>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth='lg'
                fullWidth
            >
                <DialogTitle>
                    {data.nome}
                </DialogTitle>
                <DialogContent sx={{ overflow: 'auto' }}>
                    <SecaoAdicionar
                        itens={itens}
                        setItens={setItens}
                        idWkflProcesso={data.idWkflProcesso}
                    />
                    <DragAndDrop
                        itens={itens}
                        setItens={setItens}
                        idWkflProcesso={data.idWkflProcesso}
                    />
                </DialogContent>
                <div className={styles.containerActions}>
                    <WhiteButton
                        clickFunction={onClose}
                        textValue='Fechar'
                        contentIcon={<CloseIcon />}
                    />
                </div>
            </Dialog>

            <MensagemErro
                open={openErro}
                handleClose={handleCloseSnackbarErro}
                msg={msg}
            />
        </div>
    );
};

export default ModalWorkFlow;
